export const optimizelyRolloutsConfig = {
  local: 'NQKooTCPxgoSCeExvMLYW6',
  staging: 'NQKooTCPxgoSCeExvMLYW6',
  production: 'BrsWuAPHCj4it42kQCrdvZ'
}
